import { computed, watchEffect } from 'vue'
import { useLocalStorage } from '@vueuse/core'
import webapp from '@/services/webapp'

export const useFullScreenDimensions = () => {
  const topNumberStored = useLocalStorage('topNumber', 20)

  watchEffect(() => {
    topNumberStored.value = Math.max(20, webapp.safeAreaInset.top + webapp.contentSafeAreaInset.top)
  })

  const topNumber = computed(() => topNumberStored.value)
  const bottomNumber = computed(() => Math.max(20, webapp.safeAreaInset.bottom + webapp.contentSafeAreaInset.bottom))

  const topStyle = computed(() => {
    return { top: `${topNumber.value}px` }
  })

  return {
    topStyle,
    topNumber,
    bottomNumber,
  }
}